import type { MetaFunction } from "react-router";
import { SITE_NAME } from "@/lib/constants";
import Terms from "@/pages/Terms";

export const meta: MetaFunction = () => [
  { title: `Terms of Service | ${SITE_NAME}` },
  {
    name: "description",
    content: "LoadLogo terms of service. Rules and guidelines for using the LoadLogo API.",
  },
  { property: "og:title", content: `Terms of Service | ${SITE_NAME}` },
  {
    property: "og:description",
    content: "LoadLogo terms of service. Rules and guidelines for using the LoadLogo API.",
  },
  { property: "og:type", content: "website" },
  { property: "og:url", content: "https://loadlogo.com/terms" },
  { property: "og:site_name", content: SITE_NAME },
  { name: "twitter:card", content: "summary_large_image" },
];

export default function TermsRoute() {
  return <Terms />;
}
